"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Row = _interopRequireDefault(require("./Row"));
var _Cell = _interopRequireDefault(require("./Cell"));
var _excluded = ["children", "style", "width"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Grid = function Grid(_ref) {
  var children = _ref.children,
    style = _ref.style,
    width = _ref.width,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var styles = {
    table: {
      width: width ? "".concat(width, "px") : '100%',
      borderCollapse: 'collapse'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({
    style: _objectSpread(_objectSpread({}, styles.table), style),
    width: width,
    cellSpacing: 0,
    cellPadding: 0,
    border: 0
  }, props), /*#__PURE__*/_react["default"].createElement("tbody", null, _react["default"].Children.map(children, function (el) {
    if (!el) return null;

    // We want this content the be on it's own row.
    if (el.type === _Row["default"]) {
      return el;
    }

    // The content is all inside a single cell (so a row)
    if (el.type === _Cell["default"]) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, el);
    }

    // The content is one cell inside it's own row
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, el));
  })));
};
Grid.Row = _Row["default"];
Grid.Cell = _Cell["default"];
Grid.defaultProps = {
  className: '',
  style: {},
  width: null
};
Grid.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  style: _propTypes["default"].shape({}),
  width: _propTypes["default"].number
};
var _default = exports["default"] = Grid;